import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TimeZoneService {
    private selectedTimeZone = new BehaviorSubject<string>('Europe/Belgrade');

    selectedTimeZone$ = this.selectedTimeZone.asObservable();

    constructor() {}

    setTimeZone(timeZone: string): void {
        this.selectedTimeZone.next(timeZone);
    }

    getSelectedTimeZone(): string {
        return this.selectedTimeZone.value;
    }
}
